import moment from 'moment'
import Select from 'react-select'
import pluralize from 'pluralize'
import React, { useState } from 'react'
import { AiOutlineDown } from 'react-icons/ai'
import { DatePicker, Dropdown, Menu } from 'antd'
import { Switch, Route, Link } from 'react-router-dom'

import { stringifyDate, useListData, presets, usePet } from '../../modules'

import Receive from "../../components/reusable/receive"
import SingleItemRequest from '../../components/modals/singleItemRequest'
import IssueSingleRequest from '../../components/modals/issueSingleRequest'
import Confirm from '../../components/reusable/confirm'

const { RangePicker } = DatePicker

const Returns = ({ store }) => {
    const [sString, setSString] = useState('')
    const [id, setId] = useState()
    const [qty, setQty] = useState()
    const [classif, setClass] = useState({ label:'All', value: 'All' })
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    
    const [
        { loading, error, fetch },
        { list: returns },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('returns', ranges ? {
        destination: store?._id,
        classif: classif?.value,
        string: sString,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null
    }: {
        destination: store?._id,
        classif: classif?.value,
        string: sString
    }, { notify: true })

    const refresh = resetNav => {
        if (resetNav)
            navigate(1)

        fetch()
    }

    const [, receiveReturn] = usePet('receiveReturn', {
        id, 
        quantity: qty
    }, { notify: true, hasFile: true, callback: (_, notif, ops) => {
        notif('Reversal successful', ops('success'))
        refresh()
    }, manual: true, load: { msg: 'Returning items...' } })

    const [, discardReturn] = usePet('discardReturn', {
        id
    }, { notify: true, hasFile: true, callback: (_, notif, ops) => {
        notif('Return request has been discarded', ops('success'))
        refresh()
    }, manual: true, load: { msg: 'Discarding return...' } })

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const changeClassif = val => {
        setClass(val)
        refresh()
    }

    const searchSent = str => {
        setSString(str)
        if (str?.trim()?.length > 2 || !str) {
            setSString(str)
            refresh(true)
        }
    }

    const approve = rec => {
        setId(rec._id)
        setQty(rec.quantity)
        Confirm({
            title: 'Approve Return?',
            message: 'Are you sure you want to approve this return?',
            onOk: receiveReturn,
            okText: 'Approve'
        })
    }

    const discard = rec => {
        setId(rec._id)
        Confirm({
            title: 'Discard Return?',
            message: 'Are you sure you want to discard this return?',
            onOk: discardReturn,
            okText: 'Discard'
        })
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-2">
                <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" />
                <div className="flex items-center justify-between w-full">
                    <input
                        onChange={e => searchSent(e.target.value)}
                        value={ sString }
                        className="mb-3 appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-ssearch"
                        type="text"
                        placeholder="Gisaina Kwamboka" />
                    <span className="flex">
                        <Select
                            value={classif}
                            className="mr-2"
                            onChange={ changeClassif }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ ['All', 'Pending', 'Approved', 'Discarded'].map(cls => ({ label: cls, value: cls })) }
                            placeholder="Viewed Status" />
                        <RangePicker value={ ranges } onChange={ selectRange } ranges={ presets } />
                    </span>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Return Requests</h2>
                </header>
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                returns.length > 0 ?   
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Item</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Quantity</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Source</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Requested By</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                returns.map((rtn, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ rtn.item.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{  rtn.quantity } { pluralize(rtn?.item?.issuedIn, rtn.quantity) }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ rtn.store?.name ?? rtn?.source }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ rtn.returned ? 'text-green-500' : rtn.discarded ? 'text-gray-500' : 'text-yellow-500' }>{ rtn.returned ? 'Approved' : rtn.discarded ? 'Discarded' : 'Pending' }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ rtn.returnedBy.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-left">{ stringifyDate(rtn.returnedOn) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={ `/app/store/returns/${store?._id}/${rtn._id}` }>
                                                                            <Menu.Item>View</Menu.Item>
                                                                        </Link>
                                                                        {
                                                                            !(rtn.returned && rtn.discarded) &&
                                                                            <>
                                                                                <Menu.Item onClick={ () => approve(rtn) }>Approve</Menu.Item>
                                                                                <Menu.Item onClick={ () => discard(rtn) }>Discard</Menu.Item>
                                                                            </>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex items-center justify-center h-28">
                                        <h2>No returns { sString?.trim()?.length > 2 ? `by "${sString}"` : '' } been found</h2>
                                    </div>
                            }
                        </Receive>
                        { Paginate }
                    </div>
                </div>
            </div>
            <Switch>
                <Route exact path="/app/store/returns/:id/:rq">
                    <SingleItemRequest path="/app/store/returns" onPerform={ refresh } />
                </Route>
                <Route path="/app/store/returns/:id/:rq/view">
                    <IssueSingleRequest path="/app/store/returns" onPerform={ refresh } />
                </Route>
            </Switch>
        </div>        
    )

}

export default Returns